export default __webpack_public_path__ + "static/media/introduction_vn.2fa3e32d.png";